import React from 'react';
import { Card } from 'react-toolbox/lib/card';

const MediaCard = ({ value, style }) => {
  return (
    value && (
      <Card style={{ justifyContent: 'center', ...style }}>
        <iframe
          title="video_card"
          src={value}
          frameBorder="0"
          style={{ height: '100%', width: '100%' }}
          webkitallowfullscreen
          mozallowfullscreen
          allowFullScreen
        />
      </Card>
    )
  );
};

export default MediaCard;



// WEBPACK FOOTER //
// ./src/App/join/Templates/Elements/VideoCard.js